module.exports = __webpack_public_path__ + "img/btn3.de1f7224.png";